"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectPropTypes = exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _Icon = _interopRequireDefault(require("../Icons/Icon"));
var _Input = _interopRequireDefault(require("./Input"));
var _excluded = ["initialValue", "children", "onChange"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var selectPropTypes = {
  /**
   * Name for the input field
   */
  name: _propTypes["default"].string,
  /**
   * Value for the field, to make it a controlled field
   */
  value: _propTypes["default"].string,
  /**
   * Initial value for the field
   */
  initialValue: _propTypes["default"].string,
  /**
   * Function triggered when the field value changes
   * Is also called when the clear button is clicked, with an empty string as argument
   */
  onChange: _propTypes["default"].func,
  /**
   * A ref value to be added on the rendered `input` field
   */
  forwardedRef: _propTypes["default"].any,
  /**
   * The children of the component - the options
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].arrayOf(_propTypes["default"].node)]),
  /**
   * A valid css string for the width prop
   */
  w: _propTypes["default"].string,
  /**
   * DEPRECATED: A valid css string for the width prop
   */
  width: _propTypes["default"].string,
  /*
   * Variant for the input
   */
  variant: _propTypes["default"].oneOf(["border", "filled", "activeFilled"]),
  /*
   * Is disabled
   */
  disabled: _propTypes["default"].bool,
  /*
   * Is required
   */
  isRequired: _propTypes["default"].bool
};
exports.selectPropTypes = selectPropTypes;
var Select = function Select(_ref) {
  var initialValue = _ref.initialValue,
    children = _ref.children,
    _onChange = _ref.onChange,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var theme = (0, _styledComponents.useTheme)();
  return /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({
    as: "select",
    value: initialValue,
    onChange: function onChange(e) {
      return _onChange === null || _onChange === void 0 ? void 0 : _onChange(e);
    },
    renderRight: function renderRight() {
      return /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: theme.icons.select,
        color: "inputButton",
        p: "xs"
      });
    },
    style: !otherProps.disabled ? {
      cursor: "pointer"
    } : null
  }, otherProps), children);
};
Select.propTypes = selectPropTypes;
var _default = Select;
exports["default"] = _default;